import React, { useContext, useEffect, useState } from 'react';
import { Box, IconButton, Avatar, Button, Typography } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ImgUploadDialog from '../../../components/ImgUpload/imgUpload';
import { Helpers } from '../../../services/Helpers';
import aadharFrontDefault from '../../../assets/images/aadhar-front-default.png';
import aadharBackDefault from '../../../assets/images/aadhar-back-default.png';
import { Controller, useFormContext } from 'react-hook-form';
import { UserProfileContext } from '../UserProfile';
import Swal from 'sweetalert2';
import { RemoveRedEye } from '@mui/icons-material';
import { ProviderServices } from '../CrudServices';

const AadhaarImageUpload = ({ allowVerificationOverride, canViewKycDocuments }) => {
    const { businessDetailsData, setBusinessDetailsData } = useContext(UserProfileContext);
    const { control, setValue, watch, formState: { isValid } } = useFormContext();

    const aadharNumber = watch('aadharNumber');
    const aadharFrontImage = watch('aadharFrontImage');
    const aadharRearImage = watch('aadharRearImage');
    const isAadhharVerified = Boolean(businessDetailsData?.isAadhharVerified) || (allowVerificationOverride && Boolean(watch('isAadhharVerified')));

    const [imgModalOpen, setImgModalOpen] = useState(false);
    const [imageType, setImageType] = useState(null);

    const openImageUploadModal = (imgType) => {
        setImageType(imgType);
        setImgModalOpen(true);
    };

    const closeModal = () => {
        setImgModalOpen(false);
    };

    const imgData = {
        path: "profile",
        // path: "kyc",
        // image_name: `img-${GenerateUniqueVal(1000000)}-${personalDetails.id}.jpeg`,
        img_type: "single"
    };


    const handleImageUpload = (uploadedImageData) => {
        console.log(uploadedImageData)
        // Set the uploaded PAN image URL to the form
        setValue(imageType, uploadedImageData.imageName, {
            shouldValidate: true,
            shouldDirty: true
        });
        closeModal();
    };

    const viewImage = async (image, documentType) => {
        if (!canViewKycDocuments) {
            return Swal.fire('Permission denied', 'You do not have permission to view PAN or Aadhaar images. Please contact the support team.', 'warning');
        }
        try {
            const response = await ProviderServices.logKycDocumentView({
                providerId: businessDetailsData.providerId,
                documentType
            });
            if (Number(response?.success) !== 1) throw new Error('KYC access log failed');
        } catch (error) {
            return Swal.fire('Unable to view document', 'The KYC document access could not be recorded. Please try again.', 'error');
        }
        // using swal to view image...not close on outside click
        Swal.fire({
            html: `<div style="text-align:left;font-size: 0.9rem; font-weight: 500; color: #333;">${image}</div><img src="${Helpers.ImagePathUrl()}/profile/lg/${image}" alt="Aadhaar Image" style="width:100%;height:auto;margin-top:1rem"/>`,
            showCloseButton: true,
            showConfirmButton: false,
            showCancelButton: false,
            focusConfirm: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });
    }
    useEffect(() => {
        // setProfileImage('')
    }, [])
    return (
        <>
            <ImgUploadDialog
                open={imgModalOpen}
                onClose={closeModal}
                imgData={imgData}
                imgUploadResponse={(data) => handleImageUpload(data)}
                keepOriginal={true}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', pt: { xs: 0, sm: '4%' }, gap: '.25rem' }}>
                <Box sx={{ flex: 1, textAlign: 'center' }}>
                    <Controller
                        control={control}
                        name='aadharFrontImage'
                        rules={{
                            validate: (value) => {
                                if (aadharNumber && !isAadhharVerified && !value) {
                                    return "Aadhaar Front image is required when Aadhar number is provided";
                                }
                                return true;
                            },
                        }}
                        render={({ fieldState: { error } }) => (
                            <Box sx={{ display: 'flex', gap: '3%', alignItems: 'center', flexWrap: 'wrap' }}>
                                {/* <img
                                src={aadharFrontImage && `${Helpers.ImagePathUrl()}/kyc/sm/${aadharFrontImage}` || businessDetailsData?.aadharFrontImage && `${Helpers.ImagePathUrl()}/kyc/sm/${businessDetailsData?.aadharFrontImage}` || aadharFrontDefault}
                                alt="Cover"
                                style={{ width: '100%', height: 'auto',maxWidth:'12rem',maxHeight:'7rem',borderRadius:'1rem' }}
                            /> */}
                                {(businessDetailsData.aadharNumber || aadharNumber) && <Button
                                    variant="contained"
                                    size='small'
                                    sx={{ textTransform: 'none' }}
                                    onClick={() => openImageUploadModal('aadharFrontImage')}
                                >
                                    {/* <CameraAltIcon /> */}
                                    {(aadharFrontImage || businessDetailsData.aadharFrontImage) ? 'Update Aadhaar Card (Front)' : 'Upload Aadhaar Card (Front)'}
                                </Button>}
                                {(aadharFrontImage || businessDetailsData.aadharFrontImage) && <Typography sx={{ cursor: 'pointer', fontSize: '.75rem', color: 'blue', display: { xs: 'block', sm: 'none', md: 'block' } }} onClick={() => viewImage(aadharFrontImage || businessDetailsData.aadharFrontImage, 'AADHAAR_FRONT')}>View Aadhaar Front</Typography>}

                                {(aadharFrontImage || businessDetailsData.aadharFrontImage) && <Typography sx={{ cursor: 'pointer', fontSize: '.75rem', color: 'blue', display: { xs: 'none', sm: 'block', md: 'none' } }} onClick={() => viewImage(aadharFrontImage || businessDetailsData.aadharFrontImage, 'AADHAAR_FRONT')}><RemoveRedEye /></Typography>}
                                {error && (
                                    <Typography
                                        color="error"
                                        sx={{ width: '100%', mt: 1, textAlign: 'start', fontSize: '.5rem' }}
                                    >
                                        {error.message}
                                    </Typography>
                                )}
                            </Box>
                        )}
                    />
                </Box>
                <Box sx={{ flex: 1, textAlign: 'center' }}>
                    <Controller
                        control={control}
                        name='aadharRearImage'
                        rules={{
                            validate: (value) => {
                                if (aadharNumber && !isAadhharVerified && !value) {
                                    return "Aadhaar Rear image is required when Aadhaar number is provided";
                                }
                                return true;
                            },
                        }}
                        render={({ fieldState: { error } }) => (
                            <>
                                <Box sx={{ display: 'flex', gap: '3%' }}>
                                    {/* <img
                                src={aadharRearImage && `${Helpers.ImagePathUrl()}/kyc/sm/${aadharRearImage}` || businessDetailsData?.aadharRearImage && `${Helpers.ImagePathUrl()}/kyc/sm/${businessDetailsData?.aadharRearImage}` || aadharBackDefault}
                                alt="Cover"
                                style={{ width: '100%', height: 'auto',maxWidth:'12rem',maxHeight:'7rem',borderRadius:'1rem'}}
                            /> */}
                                    {(businessDetailsData.aadharNumber || aadharNumber) && <Button
                                        variant="contained"
                                        size='small'
                                        sx={{ textTransform: 'none' }}
                                        onClick={() => openImageUploadModal('aadharRearImage')}
                                    >
                                        {/* <CameraAltIcon /> */}
                                        {(aadharRearImage || businessDetailsData.aadharRearImage) ? 'Update Aadhaar Card (Back)' : 'Upload Aadhaar Card (Back)'}
                                    </Button>
                                    }
                                    {(aadharRearImage || businessDetailsData.aadharRearImage) && <Typography sx={{ cursor: 'pointer', fontSize: '.75rem', color: 'blue' }} onClick={() => viewImage(aadharRearImage || businessDetailsData.aadharRearImage, 'AADHAAR_BACK')}>View Aadhaar Back Image</Typography>}

                                </Box>
                                {

                                    error && (
                                        <Typography
                                            color="error"
                                            sx={{ mt: 1, textAlign: 'start', fontSize: '.5rem' }}
                                        >
                                            {error?.message}
                                        </Typography>
                                    )}
                            </>
                        )}
                    />

                </Box>
            </Box>


        </>
    );
}

export default AadhaarImageUpload;
